import React from "react";
import { useApiUrl, useTranslate } from "@refinedev/core";
import { Button, Tooltip, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../authProvider";
import { IAccount } from "../../../models/account";

type AccountQontoRetryButtonProps = {
  accountId: number;
  size?: "small" | "middle";
  type?: "link" | "default" | "primary" | "text";
  showLabel?: boolean;
  onSynced?: (account: IAccount) => void;
};

export const AccountQontoRetryButton: React.FC<AccountQontoRetryButtonProps> = ({
  accountId,
  size = "small",
  type = "link",
  showLabel = true,
  onSynced,
}) => {
  const translate = useTranslate();
  const apiUrl = useApiUrl();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleRetry = async (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await axiosInstance.post<IAccount>(
        `${apiUrl}/accounts/${accountId}/qonto-sync`,
      );
      const account = response.data;
      onSynced?.(account);
      if (account.qontoSyncError) {
        message.error(
          account.qontoSyncErrorMessage ??
            translate("accounts.qontoRetrySyncFailed"),
        );
      } else {
        message.success(translate("accounts.qontoRetrySyncSuccess"));
      }
    } catch {
      message.error(translate("accounts.qontoRetrySyncFailed"));
    } finally {
      setIsLoading(false);
    }
  };

  const label = translate("accounts.qontoRetrySync", "Réessayer la sync Qonto");

  if (!showLabel) {
    return (
      <Tooltip title={label}>
        <Button
          type={type}
          size={size}
          icon={<ReloadOutlined />}
          loading={isLoading}
          onClick={handleRetry}
          aria-label={label}
        />
      </Tooltip>
    );
  }

  return (
    <Button
      type={type}
      size={size}
      icon={<ReloadOutlined />}
      loading={isLoading}
      onClick={handleRetry}
    >
      {label}
    </Button>
  );
};
